// ============================================================================
// Central SEO / GEO configuration for Talk N' Fix.
// IMPORTANT: When you point your real domain at the site, update SITE_URL below
// (and public/sitemap.xml + public/robots.txt) to that domain.
// ============================================================================

export const SITE_URL = "https://phonerepairfreehold.com";

export const GEO = {
  lat: 40.2532817,
  lng: -74.3029552,
  region: "US-NJ",
  placename: "Freehold, New Jersey",
};

export const BUSINESS = {
  name: "Talk N' Fix",
  legalName: "Talk N' Fix",
  description:
    "Talk N' Fix is a 5-star device repair shop inside the Freehold Raceway Mall (2nd level, by the food court) in Freehold, NJ. We repair iPhones, Samsung phones, iPads, tablets, MacBooks, PCs and game consoles, and sell certified pre-owned devices — all backed by a 6-month warranty.",
  telephone: "+1-732-484-5119",
  email: "varrockrepair@gmail.com",
  priceRange: "$$",
  streetAddress: "3710 US-9, 2nd Level (by the Food Court)",
  addressLocality: "Freehold",
  addressRegion: "NJ",
  postalCode: "07728",
  addressCountry: "US",
  image: "https://framerusercontent.com/images/DlTJ0wjuV9VQB8sWaScg060WfY.webp?width=1200&height=675",
  logo: `${SITE_URL}/favicon.svg`,
  mapUrl: "https://maps.app.goo.gl/P9fDEVdVq36oWYK87",
  sameAs: [
    "https://maps.app.goo.gl/P9fDEVdVq36oWYK87",
  ],
  ratingValue: "4.9",
  reviewCount: "695",
  openingHours: [
    { days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], opens: "10:00", closes: "21:00" },
    { days: ["Sunday"], opens: "11:00", closes: "18:00" },
  ],
};

export const DEFAULT_OG_IMAGE = BUSINESS.image;

// Per-route meta. Service detail pages are generated dynamically.
export const PAGE_SEO = {
  "/": {
    title: "iPhone, Computer & Console Repair | Talk N' Fix Freehold NJ",
    description:
      "Expert iPhone, iPad, MacBook, PC & game console repair inside Freehold Raceway Mall, NJ. 700+ 5-star reviews, authorized quality parts & a 6-month warranty. Same-day fixes.",
  },
  "/services": {
    title: "Device Repair Services in Freehold, NJ | Talk N' Fix",
    description:
      "Our certified techs fix it all: iPhones, Samsung, tablets, MacBooks, PCs & consoles in Freehold, NJ. 700+ 5-star reviews and a 6-month warranty on every repair.",
  },
  "/pre-owned-devices": {
    title: "Certified Pre-Owned iPhones & MacBooks | Talk N' Fix Freehold NJ",
    description:
      "Buy certified used iPhones, Samsung phones, MacBooks & iPads at Talk N' Fix inside Freehold Raceway Mall. Tested, warranted (6 months) and ready for walk-in purchase.",
  },
  "/contact": {
    title: "Contact Us | Talk N' Fix · Freehold Raceway Mall NJ",
    description:
      "Get in touch with Talk N' Fix on the 2nd level by the food court inside Freehold Raceway Mall. Call (732) 484-5119 or book your iPhone, MacBook or device repair online.",
  },
  "/repair-estimate": {
    title: "Free Repair Estimate & Appointment | Talk N' Fix Freehold NJ",
    description:
      "Get a free repair estimate and book your appointment for iPhone, Mac, PC, tablet or console repair. Same-day service & a 6-month warranty at Freehold Raceway Mall, NJ.",
  },
};
